import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { createEvent } from "src/api/events/event";
import { RESPONSSTAUTS } from "src/types/api";
import { QUERYKEYS } from "src/types/queryKeys";
import { t } from "src/utils/i18nText";

export const useCreateEvent = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [formError, setFormError] = useState({
    title: "",
    globalError: [],
    description: "",
    deadline: "",
    outcomes: "",
  });
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, isError, data, isSuccess } = useMutation({
    mutationKey: [QUERYKEYS.CREATE_EVENT],
    mutationFn: (payload: FormData) => createEvent(payload),
    onSuccess: (data) => {
      if (data.status === RESPONSSTAUTS.SUCCESS_CREATE) {
        queryClient.invalidateQueries({
          queryKey: [QUERYKEYS.USER_EVENTS],
          refetchType: "active",
        });
      } else {
        if (data.status === RESPONSSTAUTS.FAILD) {
          const errorData = data?.response?.data;
          if (errorData?.non_field_errors?.length) {
            setFormError((prev) => ({
              ...prev,
              globalError: errorData?.non_field_errors,
            }));
          } else {
            setFormError(errorData);
          }
        } else {
          const errorMsg = t("queries.common.error");
          setErrorMessage(errorMsg);
        }
      }
    },
    onError: () => {
      const errorMsg = t("queries.common.error");
      setErrorMessage(errorMsg);
    },
  });

  return {
    isSuccess,
    data,
    isError,
    isPending,
    createEventMutate: mutateAsync,
    errorMessage,
    setErrorMessage,
    formError,
    setFormError,
  };
};
